import React from "react";

// import internal components
import FilledTableRow from "./FilledTableRow";

// import external components
import { Container, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export default function TableQR({ data, deleteQR, addNewQR, updateQR }) {
    if (data.length === 0) {
        return (
            <Container
                maxWidth="md"
                sx={{
                    textAlign: 'center',
                    px: 2,
                    minHeight: '30vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"center"}

                >
                    <Typography variant="body1" color="text.secondary">
                        Hello there! You have no QR's yet to be displayed. Start adding QR's with the blue
                        button above and see your newly created QR's in an overview down below.
                    </Typography>
                </Stack>

            </Container>
        );
    }

    return (
        <TableContainer

        >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Name
                        </TableCell>
                        <TableCell>
                            UID
                        </TableCell>
                        <TableCell>
                            Target URL
                        </TableCell>
                        <TableCell>
                            Created by
                        </TableCell>
                        <TableCell>
                            Actions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((item, index) => (
                        <FilledTableRow
                            key={item.name + item.target_url}
                            addNewQR={addNewQR}
                            deleteQR={deleteQR}
                            updateQR={updateQR}
                            targetUrl={item.target_url}
                            index={index}
                            name={item.name}
                            uid={item.uid}
                            createdBy={item.created_by}
                            id={item.id}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
